import i18n from "i18next"

export const getTranslatedNotification = notification => {
  if (!notification) return ""

  // Extract values from notification message
  const extractValues = message => {
    const values = {}
    if (message.includes("lead:")) {
      const [, lead] = message.match(/lead: ([^,)]+)/) || []
      if (lead) values.lead = lead
    }
    if (message.includes("campaign:")) {
      const [, campaign] = message.match(/campaign: ([^,)]+)/) || []
      if (campaign) values.campaign = campaign
    }
    if (message.includes("account")) {
      const [, email] = message.match(/account ([^\s]+)/) || []
      if (email) values.email = email
    }
    if (message.includes("received:")) {
      const [, errorMessage] = message.match(/received: "([^"]+)"/) || []
      if (errorMessage) values.errorMessage = errorMessage
    }
    return values
  }

  const values = extractValues(notification)

  if (
    notification.includes("Connect message") &&
    notification.includes("has more than 300 characters")
  ) {
    return i18n.t("notifications.connect-message-too-long", values)
  }

  if (
    notification.includes("InMail body") &&
    notification.includes("has more than 1900 characters")
  ) {
    return i18n.t("notifications.inmail-too-long", values)
  }

  if (
    notification.includes("Your email has been disconnected") &&
    notification.includes("received:")
  ) {
    return i18n.t("notifications.email-disconnected-provider-error", values)
  }

  if (
    notification.includes("Your email has been disconnected") &&
    notification.includes("connect your account again")
  ) {
    return i18n.t("notifications.email-disconnected-try-again")
  }

  if (notification.includes("Email cooldown status detected")) {
    return i18n.t("notifications.email-cooldown", values)
  }

  if (
    notification.includes("We auto-stopped your campaign") &&
    notification.includes("bounce rate reached 8%")
  ) {
    return i18n.t("notifications.campaign-auto-stopped", values)
  }

  if (
    notification.includes("We auto-paused your campaign") &&
    notification.includes("bounce rate reached 8%")
  ) {
    return i18n.t("notifications.campaign-auto-paused", values)
  }

  if (notification.includes("out of InMails") && notification.includes("48 hours")) {
    return i18n.t("notifications.outof-inmails-48-hours")
  }

  if (notification.includes("out of InMails") && notification.includes("24 hours")) {
    return i18n.t("notifications.out-of-inmails-24-hours")
  }

  if (notification.includes("out of paid InMails") && notification.includes("24 hours")) {
    return i18n.t("notifications.out-of-paid-inmails-24-hours")
  }

  return notification
}
